import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Service, ExternalNetwork } from '../network.service';
const _ = require('lodash');

@Component({
    selector: 'create-gateway',
    templateUrl: 'create-gateway.html',
    encapsulation: ViewEncapsulation.None,
    styles: [require('./create-gateway.scss')]
})
export class CreateGateway implements OnInit {
    @Input() action: string;
    @Input() selectedGateway: any;
    @Input() opened: boolean;
    @Output() openedChange: EventEmitter<any> = new EventEmitter();
    private objectId: '';
    private name: string;
    private description: string;
    private ip: number;
    private consumedIpCount: number;
    private ipsFree: number;
    private vdc: string;
    private vdcList: string[];
    private orgList;
    private filteredVdcList;
    private externalNetwork: string;
    private externalNetworks: ExternalNetwork[];
    private availableExtNetworks: any[];
    private containsInternetUplink: boolean = true;
    private disableVdc: boolean = false;
    private disableExtNw: boolean = true;
    private disableIp: boolean = true;
    private crudResult: any[];
    private getExtNwHandler;
    private getVdcHandler;
    private selectedOrgId: string = '';
    private selectedOrgName: string = '';
    private selectedVdcName: string = '';
    objectKeys = Object.keys;
    constructor(public service: Service) {
        this.opened = false;
        this.vdcList = [];
        this.orgList = [];
        this.filteredVdcList = [];
        this.externalNetworks = [];
        this.resetForm();
    }

    ngOnInit() {
        this.getVDCList();
        this.getExternalNetworks();
    }

    ngOnChanges() {
        let me = this;
        if (this.action === 'EDIT' && this.opened) {
            let consumedIpCount = 0;
            let availableExternalNetworksOptions = this.getExternalNetworksForVdc(this.selectedGateway.vdcId);
            let selectedExternalInternetNetworks = [];
            let selectedExternalNetworks = [];
            let selectedExternalNetworkNames = [];
            let selectedExternalNetworkToEdit = '';
            if ( this.selectedGateway.configuration && this.selectedGateway.configuration.gatewayInterfaces && this.selectedGateway.configuration.gatewayInterfaces.gatewayInterface ) {
                this.selectedGateway.configuration.gatewayInterfaces.gatewayInterface.map(function(gatewayInterface, index) {
                    if (gatewayInterface.interfaceType === 'uplink') {
                        if (gatewayInterface.name.toLowerCase().indexOf('plc') === -1 && selectedExternalInternetNetworks.length < 1) {
                            let hrefSplitted = gatewayInterface.network.href.split('/');
                            // calculate the consumed IP count for the first interface
                            consumedIpCount = me.getConsumedIPCountForUplink(gatewayInterface);
                            selectedExternalInternetNetworks.push(hrefSplitted[hrefSplitted.length - 1]);
                        } else if ( selectedExternalInternetNetworks.length < 1 && selectedExternalNetworks.length < 1  ) {
                            let hrefSplitted = gatewayInterface.network.href.split('/');
                            let name = gatewayInterface.network.name;
                            let objectId = hrefSplitted[hrefSplitted.length - 1];
                            // calculate the consumed IP count for the first interface
                            consumedIpCount = me.getConsumedIPCountForUplink(gatewayInterface);
                            selectedExternalNetworks.push(objectId);
                            selectedExternalNetworkNames.push(name);
                        }
                    }
                });
            }

            if (selectedExternalInternetNetworks.length > 0) {
                // contains at least one uplink which is not direct connect
                selectedExternalNetworkToEdit = selectedExternalInternetNetworks[0];
                this.ipsFree = this.getFreeIpCountForNetwork(selectedExternalNetworkToEdit);
                this.externalNetwork = selectedExternalNetworkToEdit;
                this.availableExtNetworks = availableExternalNetworksOptions;
                this.containsInternetUplink = true;
                this.disableIp = false;
            } else {
                // contains uplinks which are not internet
                selectedExternalNetworkToEdit = selectedExternalNetworks[0];
                this.ipsFree = this.getFreeIpCountForNetwork(selectedExternalNetworkToEdit);
                this.externalNetwork = selectedExternalNetworkToEdit;
                this.availableExtNetworks = [{
                    'objectId': selectedExternalNetworkToEdit,
                    'name': selectedExternalNetworkNames[0]
                }];
                this.containsInternetUplink = false;
                this.disableIp = true;
            }

            // Init details
            this.objectId = this.selectedGateway.objectId;
            this.disableVdc = true;
            this.disableExtNw = true;
            this.name = this.selectedGateway.name;
            this.description = this.selectedGateway.description;
            this.vdc = this.selectedGateway.vdcId;
            this.ip = consumedIpCount;
            this.consumedIpCount = consumedIpCount;
            this.selectedOrgName = this.selectedGateway.orgName;
            this.selectedVdcName = this.selectedGateway.vdcName;
        }
    }

    getConsumedIPCountForUplink (network) {
        let ipCount = 0;
        let me = this;
        if (network.interfaceType === 'uplink') {
            let subnetParticipations = network.subnetParticipation;
            if (subnetParticipations.length > 0){
                subnetParticipations.map( subnetParticipation => {
                    if (subnetParticipation.ipRanges) {
                        let ipAllocations = subnetParticipation.ipRanges.ipRange;
                        if (ipAllocations.length > 0) {
                            ipAllocations.map(ipRange => {
                              if (ipRange.startAddress === ipRange.endAddress) {
                                    ipCount += 1;
                              } else {
                                    ipCount += me.getNoOfIpsBetweenRange(ipRange.startAddress, ipRange.endAddress);
                              }
                            });
                        }
                    };
                });
            }
        }
        return ipCount;
    }

    getNoOfIpsBetweenRange (startAddress, endAddress) {
        let endAddressParts = endAddress.split('.');
        let startAddressParts = startAddress.split('.');
        let endAddressNumber = endAddressParts[0] * Math.pow(2, 24)
                        + endAddressParts[1] * Math.pow(2, 16) + endAddressParts[2] * Math.pow(2, 8) + Number(endAddressParts[3]);
        let startAddressNumber = startAddressParts[0] * Math.pow(2, 24) + startAddressParts[1] * Math.pow(2, 16)
                        + startAddressParts[2] * Math.pow(2, 8) + Number(startAddressParts[3]);
        // we need to add 1 more ip to include both start and end IP in the calculation
        return (endAddressNumber - startAddressNumber) + 1;
    }

    getFreeIpCountForNetwork (externalNetworkId) {
        let freeIpCountForNetwork = 0;
        if (this.externalNetworks.length !== 0) {
            this.externalNetworks.forEach(item => {
               if (item.objectId === externalNetworkId) {
                    freeIpCountForNetwork = item.freeIpCount;
               }
            });
        }
        return freeIpCountForNetwork;
    }

    getExternalNetworkForEdit (selectedExternalNetworkId, selectedIPCount) {
        let externalNetworks = [];
        let me = this;
        if (this.selectedGateway.configuration && this.selectedGateway.configuration.gatewayInterfaces && this.selectedGateway.configuration.gatewayInterfaces.gatewayInterface) {
            this.selectedGateway.configuration.gatewayInterfaces.gatewayInterface.map(gatewayInterface => {
                if (gatewayInterface.interfaceType === 'uplink') {
                    let hrefSplitted = gatewayInterface.network.href.split('/');
                    let networkId = hrefSplitted[hrefSplitted.length - 1];
                    if (networkId === selectedExternalNetworkId) {
                        externalNetworks.push({objectId: networkId, ipCount: selectedIPCount});
                    } else {
                        externalNetworks.push({objectId: networkId, ipCount: me.getConsumedIPCountForUplink(gatewayInterface)});
                    }
                }
            });
        }
        return externalNetworks;
    }

    getVDCList() {
        let __this = this;
        this.getVdcHandler = this.service.getAllVDCs().subscribe(
            (vdcs: any) => {
                this.vdcList = vdcs.map(vdc => {
                    return {
                        name: vdc.name,
                        objectId: vdc.objectId,
                        orgName: vdc.orgName,
                        orgId: vdc.orgId
                    };
                });
                vdcs.map(function(vdc) {
                    __this.orgList[vdc.orgId] = vdc.orgName;
                });
            }
        );
    }

    getExternalNetworks() {
        this.getExtNwHandler = this.service.externalNetworks.subscribe(
            networks => this.externalNetworks = networks
        );
        this.service.getAllExternalNetworks();
    }

    getExternalNetworksForVdc(vdcId) {
        return this.externalNetworks.filter(item => item.availableVdcs.indexOf(vdcId) !== -1);
    }

    resetForm() {
        this.objectId = '';
        this.name = '';
        this.description = '';
        this.ip = 0;
        this.consumedIpCount = 0;
        this.ipsFree = 0;
        this.vdc = '';
        this.externalNetwork = '';
        this.disableVdc = false;
        this.disableExtNw = true;
        this.disableIp = true;
        this.containsInternetUplink = true;
    }

    onOrgSelect(selectedOrgId) {
        this.filteredVdcList = [];
        this.vdc = '';
        if (selectedOrgId) {
            this.filteredVdcList = this.vdcList.filter(item => item['orgId'] === selectedOrgId);
        }
        this.onVdcSelect('');
    }

    onVdcSelect(value) {
        this.disableExtNw = value ? false : true;
        this.externalNetwork = '';
        this.availableExtNetworks = [];
        if (value) {
            this.availableExtNetworks = this.getExternalNetworksForVdc(value);
        } 
        this.onExternalNetworkSelect('');
    }

    onExternalNetworkSelect(value) {
        if (value) {
            let extNw = this.externalNetworks.filter(item => item.objectId === value);
            this.disableIp = false;
            this.ip = 1;
            this.ipsFree = extNw[0].freeIpCount;
        } else {
            this.disableIp = true;
            this.ip = 0;
            this.ipsFree = 0;
        }
    }

    onSubmit(form) {
        let externalNetworks = [];

        if (this.action === 'ADD') {
            externalNetworks = [{'objectId': this.externalNetwork , 'ipCount': this.ip}];
        } else if (this.action === 'EDIT') {
            externalNetworks = this.getExternalNetworkForEdit(this.externalNetwork, this.ip);
        }

        let gateway = {
            objectId: this.objectId,
            name : this.name,
            description: this.description,
            vdcId: this.vdc,
            externalNetworks: externalNetworks
        };

        if (this.action === 'ADD') {
            this.service.createGateway(gateway)
                .subscribe(
                (crudResult: any) => {
                    this.crudResult = crudResult;
                },
                error => this.service.logError(error, 'create gateway error'),
                () => this.service.logOperationCompleted('create gateway Completed')
                );
        } else if (this.action === 'EDIT') {
            this.service.updateGateway(gateway)
                .subscribe(
                (crudResult: any) => {
                    this.crudResult = crudResult;
                },
                error => this.service.logError(error, 'update gateway error'),
                () => this.service.logOperationCompleted('update gateway Completed')
                );
        }
        this.onClose(form);
    }

    onClose(form) {
        form.reset();
        this.resetForm();
        this.opened = false;
        this.openedChange.emit(false);
    }

    ngOnDestroy() {
      if (this.getVdcHandler) {
        this.getVdcHandler.unsubscribe();
      }
      if (this.getExtNwHandler) {
         this.getExtNwHandler.unsubscribe();
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/network/gateways/create-gateway.ts